var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecryptalert03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 61.18 55.18",
    style: {
      enableBackground: "new 0 0 61.18 55.18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#34DAE2;}\n\t.st1{fill:#4C5374;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    className: "st1",
    d: "M58.58,42.29L47.89,23.77L37.2,5.26c-2.11-3.65-6.78-4.9-10.43-2.8c-1.16,0.67-2.12,1.63-2.8,2.8 L13.29,23.77L2.6,42.29c-2.11,3.65-0.86,8.32,2.79,10.43c1.16,0.67,2.48,1.02,3.82,1.02h42.76c4.22,0,7.63-3.42,7.63-7.63 C59.61,44.77,59.25,43.45,58.58,42.29z M27.36,17.09c0-1.73,1.4-3.13,3.13-3.13l0,0c1.73,0,3.13,1.4,3.13,3.13v17.27 c0,1.73-1.4,3.13-3.13,3.13l0,0c-1.73,0-3.13-1.4-3.13-3.13V17.09z M34.13,44.18c0,2.01-1.63,3.64-3.64,3.64l0,0l0,0 c-2.01,0-3.64-1.63-3.64-3.64l0,0l0,0c0-2.01,1.63-3.64,3.64-3.64l0,0l0,0C32.5,40.54,34.13,42.17,34.13,44.18L34.13,44.18z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecryptalert03);
export default __webpack_public_path__ + "static/media/recrypt alert-03.39563aa9.svg";
export { ForwardRef as ReactComponent };